import React, { useState } from 'react';
import { downloadCSV } from '_utils/csv-export';

const headerStyle = {
    border: '1px solid #e5e7eb',
    padding: '10px 14px',
    textAlign: 'left',
    backgroundColor: '#f9fafb',
    fontWeight: 600,
    fontSize: '13px',
    color: '#374151',
};

const cellStyle = {
    border: '1px solid #e5e7eb',
    padding: '10px 14px',
    textAlign: 'left',
    fontSize: '13px',
    color: '#1f2937',
};

const tableStyle = {
    border: '1px solid #e5e7eb',
    borderCollapse: 'collapse',
    width: '100%',
    tableLayout: 'fixed',
};

const subTitleStyle = {
    fontSize: '13px',
    fontWeight: 500,
    color: '#6b7280',
    marginBottom: '6px',
    marginTop: '18px',
};

const formatTimestamp = (val) => {
    if (!val) return '-';
    try {
        const d = new Date(val);
        if (Number.isNaN(d.getTime())) return String(val);
        const dateStr = d.toLocaleDateString();
        const timeStr = d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });
        return `${dateStr} ${timeStr}`;
    } catch {
        return String(val);
    }
};

const AirlinePerformancePreadvisedRawTable = ({ rawData = [] }) => {
    const [isOpen, setIsOpen] = useState(false);

    if (!rawData?.length) {
        return null;
    }

    const handleExportCsv = () => {
        const columns = ['Name', 'Booking ID', 'Flight Number', 'Airline', 'Date Created', 'Scheduled Time', 'Direction', 'Classification', 'Date'];
        const rows = rawData.map((row) => ({
            Name: row.name,
            'Booking ID': row.bookingId,
            'Flight Number': row.flightNumber,
            Airline: row.airline,
            'Date Created': formatTimestamp(row.dateCreated),
            'Scheduled Time': formatTimestamp(row.scheduledTime),
            Direction: row.direction,
            Classification: row.classification,
            Date: row.date,
        }));
        downloadCSV(rows, `preadvised-ranking-raw-${new Date().toISOString().slice(0, 10)}.csv`);
    };

    return (
        <div
            style={{
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '12px',
                marginTop: '12px',
                marginBottom: '12px',
                backgroundColor: '#fff',
            }}
        >
            <div
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    cursor: 'pointer',
                    userSelect: 'none',
                }}
            >
                <span
                    style={{
                        display: 'inline-block',
                        fontSize: '12px',
                        color: '#9ca3af',
                        transition: 'transform 0.2s ease',
                        transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
                    }}
                >
                    &#9654;
                </span>
                <p style={{ ...subTitleStyle, marginTop: 0, marginBottom: 0 }}>
                    Raw Pre-Advised Ranking Data ({rawData.length} bookings)
                </p>
                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleExportCsv();
                    }}
                    style={{
                        marginLeft: 'auto',
                        padding: '4px 10px',
                        fontSize: '12px',
                        cursor: 'pointer',
                        backgroundColor: '#f3f4f6',
                        color: '#374151',
                        border: '1px solid #e5e7eb',
                        borderRadius: '6px',
                    }}
                >
                    Export CSV
                </button>
            </div>

            {isOpen && (
                <div style={{ maxHeight: '400px', overflowY: 'auto', overflowX: 'auto', marginTop: '10px' }}>
                    <table style={tableStyle}>
                        <thead>
                            <tr>
                                <th style={headerStyle}>Passenger Name</th>
                                <th style={headerStyle}>Booking ID</th>
                                <th style={headerStyle}>Flight Number</th>
                                <th style={headerStyle}>Airline</th>
                                <th style={headerStyle}>Date Created</th>
                                <th style={headerStyle}>Scheduled Time</th>
                                <th style={headerStyle}>Direction</th>
                                <th style={headerStyle}>Classification</th>
                                <th style={headerStyle}>Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rawData.map((row, idx) => (
                                <tr key={row.bookingId ? `${row.bookingId}-${idx}` : idx}>
                                    <td style={cellStyle}>{row.name || '-'}</td>
                                    <td style={cellStyle}>{row.bookingId || '-'}</td>
                                    <td style={cellStyle}>{row.flightNumber || '-'}</td>
                                    <td style={cellStyle}>{row.airline || '-'}</td>
                                    <td style={cellStyle}>{formatTimestamp(row.dateCreated)}</td>
                                    <td style={cellStyle}>{formatTimestamp(row.scheduledTime)}</td>
                                    <td style={cellStyle}>{row.direction || '-'}</td>
                                    <td style={cellStyle}>{row.classification || '-'}</td>
                                    <td style={cellStyle}>{row.date || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default AirlinePerformancePreadvisedRawTable;
